import AxiosFactory from "@/repositories/AxiosFactory";

const resource = "logging/irc";

export default {
  store(data) {
    return AxiosFactory.post(resource, data);
  },
  update(data, id) {
    return AxiosFactory.put(`${resource}/${id}`, data);
  },
  index(data, options) {
    let query = new URLSearchParams(options).toString();
    return AxiosFactory.post(`${resource}/index?${query}`, data);
  },
  export(data) {
    return AxiosFactory.post(`${resource}/export-period`, data);
  }
};
